"use strict";

exports.__esModule = true;
var _FormattedPlantDate = require("./FormattedPlantDate");
Object.keys(_FormattedPlantDate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormattedPlantDate[key]) return;
  exports[key] = _FormattedPlantDate[key];
});